import useHttpMutation from 'data/firestore/useHttpMutation';

export default (
    agentId: string,
    pathname?: string,
) => useHttpMutation<never, Record<string, any>>({
    method: 'GET',
    pathname: pathname || `/agents/${agentId}/template-partials/export`,
});
